import { alertHide } from "./alert";
import { databaseUpdate } from "./database";
import { join } from "../channel";

export const GROUP_BETTING_POOL_ENTER_ERROR = "GROUP_BETTING_POOL_ENTER_ERROR";
export const GROUP_BETTING_POOL_ENTERING = "GROUP_BETTING_POOL_ENTERING";
export const GROUP_BETTING_POOL_ENTERED = "GROUP_BETTING_POOL_ENTERED";

export function groupBettingPoolEnter(groupBettingPoolId, quantity, currency) {
  return (dispatch) => {
    dispatch({ type: GROUP_BETTING_POOL_ENTERING, groupBettingPoolId });
    dispatch(alertHide());
    var channel = getGroupBettingPoolChannel(dispatch, groupBettingPoolId);
    channel.push("purchase_ticket", {
      quantity: quantity,
      currency: currency
    }).receive("ok", (tables) => {
      dispatch({ type: GROUP_BETTING_POOL_ENTERED, groupBettingPoolId });
      dispatch(databaseUpdate(tables));
    }).receive("error", ({ error }) => {
      dispatch({ type: GROUP_BETTING_POOL_ENTER_ERROR, groupBettingPoolId, error });
    });
  };
}

function getGroupBettingPoolChannel(dispatch, groupBettingPoolId) {
  var handlers = {
    "update": (tables) => {
      dispatch(databaseUpdate(tables));
    }
  };

  return join("group_betting_pool:" + groupBettingPoolId, (tables) => {
    dispatch(databaseUpdate(tables));
  }, undefined, handlers);
}
